import "core-js/modules/es.object.keys";
import env from '@tencent/vft-common/env';
/**
 * 获取上报类型
 * @param {VftReport.DirectiveModifiers} modifiers 指令修饰符
 *
 * @return {VftReport.ReportType}
 */

export function getReportType(modifiers) {
  return Object.keys(modifiers)[0] || 'all';
}
/**
 * 获取平台号
 */

export function getPlatform() {
  var platform = {
    iphone: 7,
    aphone: 8,
    ipad: 9,
    web: 1000,
    pc: 2000,
    mac: 2001,
    h5: 3000,

    /** 安卓手Q */
    amqq: 8001,

    /** Ios手Q */
    imqq: 8002
  };

  if (env.isIpad) {
    return platform.ipad;
  }

  if (env.isApp) {
    if (env.isAndroid) {
      return platform.aphone;
    }

    if (env.isIphone) {
      return platform.iphone;
    }

    if (env.isPCClient) {
      return platform.pc;
    }

    if (env.isMac) {
      return platform.mac;
    }
  }

  if (env.isMqq) {
    if (env.isAndroid) {
      return platform.amqq;
    }

    if (env.isIphone) {
      return platform.imqq;
    }
  }

  return platform.h5;
}